'use client';

import { useEffect, useRef, useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { CartPreview } from '@/features/cart/shared/components/cart-preview';
import { useAppStore } from '@/features/shared/app-store';
import { CounterBadge } from '@/shared/components/counter-badge';

export const CartLink = () => {
  const t = useTranslations('Cart');
  const items = useAppStore((s) => s.cart.items);
  const itemCount = items.length;

  const [showPreview, setShowPreview] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setShowPreview(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className='group focus-visible:ring-primary relative flex cursor-pointer items-center gap-2 rounded-xs p-1 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-1'
      aria-label={t('shoppingCartWithItems', { itemCount })}
      onClick={() => setShowPreview((prev) => !prev)}
    >
      <ShoppingCart height={22} width={22} fill='white' aria-hidden='true' />
      <span
        className='group-hover:text-text-hover self-end text-sm font-semibold transition-colors'
        aria-live='polite'
      >
        <CounterBadge count={itemCount} />
      </span>
      {showPreview && <CartPreview items={items} />}
    </div>
  );
};
